import { ThemeProvider } from '@emotion/react'
import theme from '@/constants/theme'

export function EmotionProvider({ children }: { children: React.ReactNode }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
